module.exports = __webpack_public_path__ + "media/images/logo-red-square-00e998afa9a9fb12e20b6906ee21b449.png";